import { InjectionToken, Optional, Provider, SkipSelf, Type } from '@angular/core';

import { STANDARD_CART_ITEM_RESULT_VIEW_COMPONENTS, WIRE_CUT_CART_ITEM_RESULT_VIEW_COMPONENTS } from '../../../types';
import { ProvideCartItemResultComponentConfig } from './ProvideCartItemResultComponentConfig';
import { ProductTypes } from 'products-data';

export function provideCartItemResultComponent(config: ProvideCartItemResultComponentConfig): Provider[] {
  let provide: InjectionToken<Type<unknown>[]>;
  switch (config.type) {
    case ProductTypes.Wire:
      provide = WIRE_CUT_CART_ITEM_RESULT_VIEW_COMPONENTS;
      break;
    case ProductTypes.Standard:
    default:
      provide = STANDARD_CART_ITEM_RESULT_VIEW_COMPONENTS;
      break;
  }
  if (config.merge) {
    return [
      {
        provide,
        useFactory: (parent: Type<unknown>[] | null) => [...(parent ?? []), config.component],
        deps: [[new Optional(), new SkipSelf(), provide]],
      },
    ] as Provider[];
  }
  return [
    {
      provide,
      useValue: config.component,
      multi: true,
    },
  ] as Provider[];
}
